import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AlertService, AuthenticationService } from '../_services';
import { Store } from '@ngrx/store';
import { LoginUser } from './../store/actions/appActions';
import { environment } from './../../environments/environment';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(formBuilder, route, router, authenticationService, alertService, store) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.authenticationService = authenticationService;
        this.alertService = alertService;
        this.store = store;
        this.loading = false;
        this.submitted = false;
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (typeof this.route.snapshot.queryParams['token'] !== 'undefined') {
            this.access_token = this.route.snapshot.queryParams['token'];
            this.league_type = this.route.snapshot.queryParams['league_type'];
            this.draftID = this.route.snapshot.queryParams['league_code'];
            var tournament_1 = '';
            var round_no_1 = '';
            var tour_league_id_1 = '';
            if (typeof this.route.snapshot.queryParams['tournament'] !== 'undefined') {
                tournament_1 = this.route.snapshot.queryParams['tournament'];
                round_no_1 = this.route.snapshot.queryParams['round_no'];
                tour_league_id_1 = this.route.snapshot.queryParams['league_id'];
            }
            this.submitted = false;
            this.loading = true;
            this.authenticationService.login_token(this.access_token)
                .pipe(first())
                .subscribe(function (data) {
                if (data.message === 'Access granted') {
                    _this.store.dispatch(new LoginUser({
                        user_id: data.data.data.id,
                        user_name: data.data.data.username,
                        drafters_id: data.data.data.drafters_id
                    }));
                    if (tournament_1 && (tournament_1 === "" + environment.tournament)) {
                        _this.router.navigate(['/resultboard/draft/players/' + _this.league_type + '/' + _this.draftID + '/' + tournament_1 + '/' + round_no_1 + '/' + tour_league_id_1]);
                    }
                    else {
                        _this.router.navigate(['/resultboard/draft/players/' + _this.league_type + '/' + _this.draftID]);
                    }
                }
                else {
                    window.location.href = "" + environment.SITE_URL;
                    //this.router.navigate([`${environment.SITE_URL}`]);
                }
            }, function (error) {
                window.location.href = "" + environment.SITE_URL;
                _this.alertService.error(error);
                _this.loading = false;
            });
        }
        else {
            window.location.href = "" + environment.SITE_URL;
        }
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
        // reset login status
        this.authenticationService.logout();
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    };
    Object.defineProperty(LoginComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () { return this.loginForm.controls; },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.onSubmit = function () {
        var _this = this;
        this.submitted = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }
        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .pipe(first())
            .subscribe(function (data) {
            _this.router.navigate(['/']);
        }, function (error) {
            _this.alertService.error(error);
            _this.loading = false;
        });
    };
    return LoginComponent;
}());
export { LoginComponent };
